define('home/mixins/withAllstarPopover',[
    'underscore',

    'home/utils/confirmModal',
    'home/templates/allstarModal',
], function (
    _,

    confirmModal,
    allstarModalTemplate
) {
    'use strict';

    /**
     * Adds to the allstar icon a tooltip and on-click modal with additional
     * information about allstars.
     */
    var withAllstarPopover = {
        events: {
            'click [data-action=show-allstar-modal]': 'showAllstarModal',
        },

        onDomRefresh: function (_onDomRefresh) {
            if (_onDomRefresh)
                _onDomRefresh.call(this);

            this.$('[data-toggle=tooltip]').tooltip();
        },

        // Debounce this in case an allstar icon appear in a nested view where multiple
        // click handlers are bound by multiple views.
        showAllstarModal: _.debounce(function () {
            confirmModal.getModal({
                modal: {
                    type: confirmModal.TYPES.CLOSE_ICON,
                    content: allstarModalTemplate(),
                },
            }).modal('show');
        }),
    };

    return function () {
        this.events = _.extend({}, withAllstarPopover.events, this.events);
        this.onDomRefresh = _.wrap(this.onDomRefresh, withAllstarPopover.onDomRefresh);
        _.defaults(this, _.pick(withAllstarPopover, [
            'showAllstarModal',
        ]));
    };
});

